import { InjectionKey } from "vue";

export const getInjectionKey = <T>() => Symbol() as InjectionKey<T>;
